import { inc, dec, incBody, decBody, incLab, decLab,
         LOW_INC, MED_INC, HIGH_INC } from '../gameState';

// APPLY FUNCTIONS
const applyAI = (gameContext, includeAxis) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      gynecomastia: decBody(gameContext.body.gynecomastia, LOW_INC),
      sexualDysfunction: incBody(gameContext.body.sexualDysfunction, LOW_INC),
    },
    bloodwork: {
      ...gameContext.bloodwork,
      dexa: incLab(gameContext.bloodwork.dexa, LOW_INC),
      ekg: incLab(gameContext.bloodwork.ekg, LOW_INC),
      tte: incLab(gameContext.bloodwork.tte, LOW_INC),
      freeTestosterone: incLab(gameContext.bloodwork.freeTestosterone, LOW_INC)
    }
  };
  if (includeAxis) {
    newState.axis["HPA_AIS"].count += 1;
  }
  return newState;
}

const applyDiuretics = (gameContext) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      bodyFat: decBody(gameContext.body.bodyFat, LOW_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      bmp: incLab(gameContext.bloodwork.bmp, HIGH_INC)
    }
  };
  return newState;
}

const applyHCG = (gameContext, includeAxis) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      gynecomastia: incBody(gameContext.body.gynecomastia, LOW_INC)
    }
  };
  if (includeAxis) {
    newState.axis["HPA_HCG"].count += 1;
  }
  return newState;
}

const applyHGH = (gameContext) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      bodyFat: incBody(gameContext.body.bodyFat, MED_INC),
      muscleMass: incBody(gameContext.body.muscleMass, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC)
    }
  };
  return newState;
}

const applyInjection = (gameContext, includeAxis) => {
  const newState = {
    ...gameContext,
    bioClock: dec(gameContext.bioClock, MED_INC),
    body: {
      ...gameContext.body,
      acne: incBody(gameContext.body.acne, MED_INC),
      bodyFat: decBody(gameContext.body.bodyFat, LOW_INC),
      gynecomastia: incBody(gameContext.body.gynecomastia, MED_INC),
      hair: incBody(gameContext.body.hair, MED_INC),
      infectionRisk: incBody(gameContext.body.infectionRisk, MED_INC),
      mood: incBody(gameContext.body.mood, MED_INC),
      muscleMass: incBody(gameContext.body.muscleMass, MED_INC),
      sexualDysfunction: incBody(gameContext.body.sexualDysfunction, MED_INC),
      tendonRupture: incBody(gameContext.body.tendonRupture, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      bmp: incLab(gameContext.bloodwork.bmp, MED_INC),
      cbc: incLab(gameContext.bloodwork.cbc, MED_INC),
      lft: incLab(gameContext.bloodwork.lft, LOW_INC),
      psa: incLab(gameContext.bloodwork.psa, LOW_INC),
      hiv: incLab(gameContext.bloodwork.hiv, LOW_INC),
      ekg: incLab(gameContext.bloodwork.ekg, LOW_INC),
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC),
      calciumScore: incLab(gameContext.bloodwork.calciumScore, LOW_INC),
      cardiacStressTest: incLab(gameContext.bloodwork.cardiacStressTest, LOW_INC)
    }
  };
  if (includeAxis) {
    newState.axis["HPA_AAS"].count += 1;
  }
  return newState;
}

const applyInsulin = (gameContext) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      muscleMass: incBody(gameContext.body.muscleMass, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      hemoglobin: incLab(gameContext.bloodwork.hemoglobin, LOW_INC)
    }
  };
  return newState;
}

const applyOral = (gameContext, includeAxis) => {
  const newState = {
    ...gameContext,
    bioClock: dec(gameContext.bioClock, MED_INC),
    body: {
      ...gameContext.body,
      acne: incBody(gameContext.body.acne, MED_INC),
      bodyFat: decBody(gameContext.body.bodyFat, LOW_INC),
      gynecomastia: incBody(gameContext.body.gynecomastia, MED_INC),
      hair: incBody(gameContext.body.hair, MED_INC),
      mood: incBody(gameContext.body.mood, MED_INC),
      muscleMass: incBody(gameContext.body.muscleMass, MED_INC),
      sexualDysfunction: incBody(gameContext.body.sexualDysfunction, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      lft: incLab(gameContext.bloodwork.lft, HIGH_INC),
      cbc: incLab(gameContext.bloodwork.cbc, LOW_INC),
      psa: incLab(gameContext.bloodwork.psa, LOW_INC),
      hiv: incLab(gameContext.bloodwork.hiv, LOW_INC),
      ekg: incLab(gameContext.bloodwork.ekg, LOW_INC),
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC),
      calciumScore: incLab(gameContext.bloodwork.calciumScore, LOW_INC),
      cardiacStressTest: incLab(gameContext.bloodwork.cardiacStressTest, LOW_INC)
    }
  };
  if (includeAxis) {
    newState.axis["HPA_AAS"].count += 1;
  }
  return newState;
}

const applySARM = (gameContext) => {
  const newState = {
    ...gameContext,
    body: {
      ...gameContext.body,
      muscleMass: incBody(gameContext.body.muscleMass, LOW_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      bmp: incLab(gameContext.bloodwork.bmp, MED_INC),
      cbc: incLab(gameContext.bloodwork.cbc, MED_INC),
      lft: incLab(gameContext.bloodwork.lft, LOW_INC),
      psa: incLab(gameContext.bloodwork.psa, LOW_INC),
      hiv: incLab(gameContext.bloodwork.hiv, LOW_INC),
      ekg: incLab(gameContext.bloodwork.ekg, LOW_INC),
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC)
    }
  }
  return newState;
}

const applyClomid = (gameContext, includeAxis) => {
  const newClock = inc(gameContext.bioClock, LOW_INC);
  const newState = {
    ...gameContext,
    bioClock: newClock,
    body: {
      ...gameContext.body,
      gynecomastia: decBody(gameContext.body.gynecomastia, MED_INC),
      headache: incBody(gameContext.body.headache, MED_INC),
      visualDisturbances: incBody(gameContext.body.visualDisturbances, MED_INC),
      vasomotorSymptoms: incBody(gameContext.body.vasomotorSymptoms, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC)
    }
  };

  if (includeAxis) {
    let key;
    if (gameContext.axis["HPA_AAS"].count) {
      // on cycle with AAS: low dose
      key = "HPA_CLOMID_LOW";
    } else {
      // post cycle therapy: high dose
      // if bioclock is below a certain threshold, no return of HPA axis
      if (newClock > 50) {
        key = "HPA_CLOMID_HIGH";
      } else {
        key = "HPA_NO_AXIS";
      }
    }
  
    if (key) {
      newState.axis[`${key}`].count += 1;
      const name = newState.history.pop();
      newState.history = [...newState.history, `${name}-${key}`];
    }
  }

  return newState;
}

const applyTamoxifen = (gameContext, includeAxis) => {
  const newClock = inc(gameContext.bioClock, LOW_INC);
  const newState = {
    ...gameContext,
    bioClock: newClock,
    body: {
      ...gameContext.body,
      deepVeinThrombosis: incBody(gameContext.body.deepVeinThrombosis, MED_INC),
      gynecomastia: decBody(gameContext.body.gynecomastia, MED_INC),
      headache: incBody(gameContext.body.headache, MED_INC),
      pulmonaryEmbolism: incBody(gameContext.body.pulmonaryEmbolism, MED_INC),
      strokeRisk: incBody(gameContext.body.strokeRisk, MED_INC),
      visualDisturbances: incBody(gameContext.body.visualDisturbances, MED_INC),
      vasomotorSymptoms: incBody(gameContext.body.vasomotorSymptoms, MED_INC)
    },
    bloodwork: {
      ...gameContext.bloodwork,
      dexa: incLab(gameContext.bloodwork.dexa, LOW_INC),
      lipid: incLab(gameContext.bloodwork.lipid, LOW_INC)
    }
  };

  if (includeAxis) {
    let key;
    if (gameContext.axis["HPA_AAS"].count) {
      // on cycle with AAS: low dose
      key = "HPA_CLOMID_LOW";
    } else {
      // post cycle therapy: high dose
      // if bioclock is below a certain threshold, no return of HPA axis
      if (newClock > 50) {
        key = "HPA_CLOMID_HIGH";
      } else {
        key = "HPA_NO_AXIS";
      }
    }
  
    if (key) {
      newState.axis[`${key}`].count += 1;
      const name = newState.history.pop();
      newState.history = [...newState.history, `${name}-${key}`];
    }
  }

  return newState;
}

// UNDO FUNCTIONS
const undoInjection = (gameContext) => {
  const newState = {...gameContext};
  newState.axis["HPA_AAS"].count = dec(newState.axis["HPA_AAS"].count, 1);
  return newState;
}

const undoOral = undoInjection;

const undoAI = (gameContext) => {
  const newState = {...gameContext};
  newState.axis["HPA_AIS"].count = dec(newState.axis["HPA_AIS"].count, 1);
  return newState;
}

const undoSERM = (gameContext, nameToRemove) => {
  const key = nameToRemove.split("-")[1];
  const newState = {...gameContext}
  newState.axis[`${key}`].count = dec(newState.axis[`${key}`].count, 1);
  return newState;
}

const undoHCG = (gameContext) => {
  const newState = {...gameContext};
  newState.axis["HPA_HCG"].count = dec(newState.axis["HPA_HCG"].count, 1);
  return newState;
}

const INPUTS = {
  // steroids
  injection: {
    name: "Steroid Injection",
    apply: applyInjection,
    undo: undoInjection
  },
  oral: {
    name: "Oral Steroids",
    apply: applyOral,
    undo: undoOral
  },

  // SERMs
  clomiphene: {
    name: "Clomiphene (Clomid)",
    apply: applyClomid,
    undo: undoSERM
  },
  tamoxifen: {
    name: "Tamoxifen (Nolvadex)",
    apply: applyTamoxifen,
    undo: undoSERM
  },

  // aromatase inhibitors
  anastrazole: {
    name: "Anastrozole (Arimidex)",
    apply: applyAI,
    undo: undoAI
  },
  exemestane: {
    name: "Exemestane (Aromasin)",
    apply: applyAI,
    undo: undoAI
  },

  // other peds
  insulin: {
    name: "Insulin",
    apply: applyInsulin
  },
  hgh: {
    name: "hGH",
    apply: applyHGH
  },
  diuretics: {
    name: "Diuretics",
    apply: applyDiuretics
  },
  sarms: {
    name: "SARMs",
    apply: applySARM
  },
  hcg: {
    name: "hCG",
    apply: applyHCG,
    undo: undoHCG
  }
}

export default INPUTS;